import { useEffect } from 'react'
import { useAppDispatch } from 'store'
import { useCurrentSymbol } from 'store/market/hooks'
import {clearOrderbookAction, getOrderbookAction,getRecentHistoryAction } from './actions'

function useFetchOrderbook() {
  const dispatch = useAppDispatch()
  const { name = '' } = useCurrentSymbol()
  useEffect(() => {
    if (!name) return
    dispatch(getOrderbookAction(name))

    dispatch(getRecentHistoryAction(name))
  }, [dispatch, name])
}

export default function Updater() {
  useFetchOrderbook()

  return null
}
